__turbopack_context__.v({
  "badge": "StartingSoonBadge-module__A9rkiG__badge",
  "badgeLabel": "StartingSoonBadge-module__A9rkiG__badgeLabel",
});
